var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.webGis = new function() {
    //https://mapcentia.screenstepslive.com/s/21003/m/83819/l/1063906-indlejring
    //https://github.com/mapcentia/vidi

    var ua = window.navigator.userAgent;
    var isIE = /MSIE|Trident/.test(ua);

    var self = this;

    this.webGisContainerIdIndex = 1;

    this.init = function() {
        $('.is-web-gis').click(function(event) {
            event.preventDefault();
            self.openWebGisMap($(this));
            return false;
        });

        if($('.is-web-gis-natbusser').length) {
            $(window).on('load', function(event) {
                event.preventDefault();
                self.openWebGisMap($('.is-web-gis-natbusser'));
                return false;
            });
        }

        $('.is-web-gis-natbusser').click(function(event) {
            event.preventDefault();
            self.openWebGisMap($(this));
            return false;
        });
    };

    this.openContainingWebGisMaps = function(elm) {
        var elements = elm.find('.is-web-gis');
        for (var i = 0; i < elements.length; i++) {
            self.openWebGisMap($(elements[i]));
        }
    };

    this.openWebGisMap = function(elm) {
        //Create unique container id for this element

        if(isIE) {
            elm.parent().closest('div').append($(document.createElement('div'))
            .text('Rutekortet kan ikke vises i Internet Explorer. Skift til en anden browser for at få kortet vist.'));
            return;
        }

        if (!elm.attr('data-nc-web-gis-container-id')) {
            elm.attr('data-nc-web-gis-container-id', 'nc-web-gis-container-id-' + self.webGisContainerIdIndex++);
        }

        //Test if map exists
        if ($('#' + elm.attr('data-nc-web-gis-container-id')).length > 0)
            return;

        var gisMap = $(document.createElement('div'))
        .attr('class', 'web-gis-container')
        .attr('id', elm.attr('data-nc-web-gis-container-id'))
        .attr('data-vidi-token', elm.attr('data-webgistoken'))
        .attr('data-vidi-history', 'none')
        .attr('data-vidi-use-config', 'true');

        gisMap.insertAfter(elm)

        //Add vidi script
        if ($('#vidijsinclude').length === 0)
            $('body').append($(document.createElement('script')).attr('id', 'vidijsinclude').attr('src', 'https://vidi.swarm.gc2.io/js/embed.js'));
    };
};
